<template>
  <div class="tableDiv" :style="{ height: options.tableHeight + 'px' }">
    <!-- <el-table :data="list" v-loading="options.loading" border stripe fit style="width: 100%"  :height="tableHeight" @selection-change="handleSelectionChange"> -->
    <el-table
      :data="list"
      border
      stripe
      fit
      style="width: 100%"
      :max-height="options.tableHeight"
      @selection-change="handleSelectionChange"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="no-data">
          <i class="crm-wu"></i>
          <span class="text-1">{{ options.errortip }}</span>
        </div>
      </template>
      <!--region 选择框-->
      <el-table-column
        v-if="
          options.mutiSelect &&
          !options.mutiSelectDisable &&
          !options.mutiSelectTwoDisable
        "
        align="center"
        type="selection"
        style="width: 55px"
      ></el-table-column>
      <el-table-column
        v-if="options.mutiSelect && options.mutiSelectDisable"
        type="selection"
        align="center"
        :selectable="checkboxInit"
        style="width: 55px"
      ></el-table-column>
      <el-table-column
        v-if="options.mutiSelect && options.mutiSelectTwoDisable"
        type="selection"
        align="center"
        :selectable="checkboxInitTwo"
        style="width: 55px"
      ></el-table-column>
      <!--endregion-->
      <!-- 编辑列start -->
      <template v-for="(column, $index) in columns">
        <template v-if="column.isfixed">
          <el-table-column
            :prop="column.prop"
            :key="`${Math.random()}-${$index}`"
            :fixed="column.fixed"
            :label="column.label"
            :align="column.align"
            min-width="150px"
            v-if="column.isShow"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <!-- client_actisagree   活动录入是否同意后期使用  0 不同意  1 同意 -->
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index, scope.row)"
              >
                <div class="flex items-center">
                  <span class="mr5">{{ list[scope.$index][column.prop] }}</span>
                  <i
                    v-if="
                      options.isShowPersonInfo &&
                      column.isShowRule == '1' &&
                      scope.row.client_actisagree == '0'
                    "
                    class="crmIcon-ysbh mr5"
                  ></i>

                  <el-tooltip
                    effect="light"
                    :content="scope.row.warninginfo"
                    placement="right"
                    v-if="options.isShowPersonInfo && scope.row.overduetype == 2"
                  >
                    <span class="el-icon-time color-red"></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="scope.row.warninginfo"
                    placement="right"
                    v-if="options.isShowPersonInfo && scope.row.overduetype == 3"
                  >
                    <span class="el-icon-warning color-orange"></span>
                  </el-tooltip>

                  <!--isschoolread  是否已读  1是  0 否 -->
                  <span
                    v-if="
                      column.isReadStatus && scope.row.client_isnewtip == '1'
                    "
                    class="no-readTips"
                  >
                    {{ $t("Table.noreadTips") }}
                  </span>
                </div>
              </el-button>
              <span v-else type="text">
                {{ list[scope.$index][column.prop] }}
                <i
                  v-if="
                    options.isShowPersonInfo &&
                    column.isShowRule == '1' &&
                    scope.row.client_actisagree == '0'
                  "
                  class="crmIcon-ysbh mr5"
                ></i>
              </span>
            </template>
          </el-table-column>
        </template>
        <!-- 标签列 -->
        <template v-else-if="column.istag">
          <el-table-column
            :prop="column.prop"
            :key="`${Math.random()}-${$index}`"
            :fixed="column.fixed"
            :label="column.label"
            :align="column.align"
            :show-overflow-tooltip="true"
            :min-width="column.width ? column.width : '150px'"
            v-if="column.isShow"
          >
            <template slot-scope="scope">
              <div class="table-tags-list" v-if="list[scope.$index][column.prop].length">
                <el-tag
                  class="tag-sty"
                  v-for="(item, index) in list[scope.$index][column.prop]"
                  :key="index"
                  >{{ item }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
        </template>

        <template v-else>
          <el-table-column
            :prop="column.prop"
            :key="`${Math.random()}-${$index}`"
            :label="column.label"
            :align="column.align"
            :show-overflow-tooltip="true"
            min-width="150px"
            v-if="column.isShow"
          >
            <!-- 判断意向星级 -->
            <!-- 判断二维码 -->
            <template slot-scope="scope">
              <el-button
                v-if="column.isWxCode"
                @click="handleCodeChange(scope.$index, scope.row, column)"
                type="primary"
                size="small"
              >
                查看{{ column.isschool == 1 ? "学校" : "个人" }}二维码
              </el-button>
              <div
                v-else-if="column.iscode"
                class="table-code"
                @click="handleCodeChange(scope.$index, scope.row, column)"
              >
                <img :src="list[scope.$index][column.prop]" />
              </div>
              <template v-else-if="!column.islevel">
                <template v-if="list[scope.$index][column.prop]">
                  {{ list[scope.$index][column.prop] }}
                  <!--判断手机号是本地还是外地 isoutmobile 0 本地  1外地-->
                  <span
                    v-if="column.isTypeTab"
                    class="phone-tips"
                    :class="{ 'field-phone': scope.row.isoutmobile == 1 }"
                  >
                    {{
                      scope.row.isoutmobile == 1
                        ? $t("Table.label_text3")
                        : $t("Table.label_text4")
                    }}
                  </span>
                </template>
                <template v-else>--</template>
              </template>
              <!-- 判断意向星级 -->
              <span v-else>
                <i
                  v-for="n in Number(list[scope.$index][column.prop])"
                  :key="n"
                  class="icon-heart-off"
                ></i>
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 编辑列end -->
      <!--region 按钮操作组-->
      <!-- 下拉操作组 -->
      <el-table-column
        ref="fixedColumn"
        :label="operates.label"
        :align="operates.align"
        width="150px"
        :fixed="operates.fixed"
        v-if="
          operates.dropDown &&
          operates.list.filter((_x) => _x.show === true).length > 0
        "
      >
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            @command="handleCommand"
            @visible-change="dropdownClick(scope.row)"
          >
            <span class="el-dropdown-link">
              <span style="color: #20a8d8">{{ $t("Common.workMenu") }}</span>
              <i class="el-icon-arrow-down el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(btn, key) in operates.list">
                <el-dropdown-item
                  v-if="
                    btn.show &&
                    btn.noPermission &&
                    postbe_crmlevel == '1' &&
                    scope.row.client_distributionstatus == '0'
                  "
                  :key="`${Math.random()}-${key}`"
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-else-if="
                    btn.show &&
                    btn.floowMe &&
                    scope.row.client_distributionstatus == '0'
                  "
                  :key="`${Math.random()}-${key}`"
                  divided
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>
                <!-- 集团招生 限制 转校 -->
                <el-dropdown-item
                  v-else-if="
                    btn.show &&
                    btn.changeSchool &&
                    scope.row.client_distributionstatus == '0' &&
                    !(
                      scope.row.isgmcIndschoolenter == 1 &&
                      scope.row.isgmcschoolenter != 1
                    )
                  "
                  :key="`${Math.random()}-${key}`"
                  divided
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-else-if="
                    btn.show &&
                    btn.delRepeat &&
                    parseInt(scope.row.is_repeat) > 0
                  "
                  :key="`${Math.random()}-${key}`"
                  divided
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-else-if="
                    btn.show &&
                    btn.comeToVisit &&
                    companyId == 8888 &&
                    scope.row.channel_id == 436 &&
                    scope.row.ishaveinvite == 0
                  "
                  :key="`${Math.random()}-${key}`"
                  divided
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>

                <el-dropdown-item
                  v-else-if="btn.show && btn.toInvi && postbeCrmlevel == 1"
                  :key="`${Math.random()}-${key}`"
                  divided
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>

                <el-dropdown-item
                  v-else-if="
                    !btn.noPermission &&
                    !btn.floowMe &&
                    !btn.delRepeat &&
                    !btn.changeSchool &&
                    !btn.comeToVisit &&
                    !btn.toInvi
                  "
                  :key="`${Math.random()}-${key}`"
                  divided
                  :command="btn.name"
                >
                  {{ btn.label }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column
        ref="fixedColumn"
        :label="operates.label"
        :align="operates.align"
        :width="operates.width"
        :fixed="operates.fixed"
        v-else-if="operates.list.filter((_x) => _x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <template v-for="(btn, key) in operates.list">
            <template v-if="btn.show && btn.changeAppoint">
              <div
                class="item"
                v-if="
                  scope.row.invite_isvisit == 0 ||
                  scope.row.is_visit_autition == '0'
                "
                :key="`${Math.random()}-${key}`"
              >
                <el-button
                  @click.native.prevent="btn.method(key, scope.row)"
                  :type="btn.type"
                  size="small"
                  :disabled="btn.disabled"
                >
                  改约
                </el-button>
              </div>
            </template>

            <div
              class="item"
              v-else-if="btn.show && scope.row.is_visit_autition"
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition == '1'"
              ></el-button>
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition == '0'"
                >{{ btn.label }}</el-button
              >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition == '-1'"
              ></el-button>
            </div>
            <div
              class="item"
              v-if="btn.show && btn.noPermission"
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="
                  postbe_crmlevel == '1' &&
                  scope.row.client_distributionstatus == '0'
                "
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-if="btn.show && btn.ischaserlapsed && postbe_crmlevel == '1'"
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.isshenhe != '1'"
                >{{ btn.label }}</el-button
              >
              <template v-else>--</template>
            </div>
            <div
              class="item"
              v-if="
                btn.show &&
                btn.is_active_del &&
                (postbe_crmlevel == '1' ||
                  (postbe_crmlevel == '3' &&
                    scope.row.marketer_id == marketer_id))
              "
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.activity_type != '1'"
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-if="
                btn.show &&
                companyIsmajor == '2' &&
                btn.is_active_copy &&
                postbe_crmlevel == '1'
              "
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                >{{ btn.label }}</el-button
              >
            </div>
            <!-- && scope.row.activity_type == '0' -->
            <div
              class="item"
              v-if="
                btn.show && btn.promotion_qrcode && scope.row.promotion_qrcode
              "
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
              >
                {{ btn.label }}
              </el-button>
            </div>
            <div
              class="item"
              v-if="
                btn.show && btn.floowMe && scope.row.client_distributionstatus
              "
              :key="`${Math.random()}-${key}`"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.client_distributionstatus == '0'"
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-else-if="
                btn.show &&
                !scope.row.is_visit_autition &&
                !btn.noPermission &&
                !btn.ischaserlapsed &&
                !btn.floowMe &&
                !btn.is_active_del &&
                !btn.is_active_copy &&
                !btn.promotion_qrcode
              "
              :key="`${Math.random()}-${key}`"
            >
              <template v-if="!btn.isApplayChange">
                <template v-if="btn.Customfloow">
                  <template v-if="postbe_crmlevel != 3">
                    <!-- 意向客户跟进开始 -->
                    <el-button
                      @click.native.prevent="btn.method(key, scope.row)"
                      :type="btn.type"
                      size="small"
                      :disabled="btn.disabled"
                      class="btn-noclick"
                      v-if="scope.row.client_forbid == 0"
                    >
                      {{ btn.label }}
                    </el-button>
                    <el-button
                      @click.native.prevent="btn.method(key, scope.row)"
                      :type="btn.type"
                      size="small"
                      :disabled="btn.disabled"
                      v-else
                    >
                      {{ btn.label }}
                    </el-button>
                  </template>
                </template>
                <!-- 意向客户跟进结束 -->
                <!-- 意向客户转正 -->
                <el-button
                  @click.native.prevent="btn.method(key, scope.row)"
                  :type="btn.type"
                  size="small"
                  v-else-if="
                    btn.turnPositive &&
                    scope.row.client_tracestatus != 4 &&
                    scope.row.client_tracestatus != -1 &&
                    scope.row.is_positive != 0
                  "
                  :disabled="btn.disabled"
                  >{{ btn.label }}</el-button
                >
                <!-- 删除重复名单 -->
                <el-button
                  @click.native.prevent="btn.method(key, scope.row)"
                  :type="btn.type"
                  size="small"
                  v-else-if="btn.delRepeat"
                  :disabled="btn.disabled"
                  >{{ btn.label }}</el-button
                >
                <!-- && parseInt(scope.row.is_repeat) > 0 -->
                <el-button
                  @click.native.prevent="btn.method(key, scope.row)"
                  :type="btn.type"
                  size="small"
                  v-else-if="btn.trunSchool && postbe_crmlevel == '1'"
                  :disabled="btn.disabled"
                  >{{ btn.label }}</el-button
                >
                <el-button
                  @click.native.prevent="btn.method(key, scope.row)"
                  :type="btn.type"
                  size="small"
                  v-else-if="
                    !btn.turnPositive && !btn.delRepeat && !btn.trunSchool
                  "
                  :disabled="btn.disabled"
                  >{{ btn.label }}</el-button
                >
              </template>
              <el-button
                v-else
                @click.native.prevent="
                  scope.row.apply == 1 ? btn.method(key, scope.row) : ''
                "
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                :style="{
                  color: scope.row.apply == 0 && '#aaa',
                }"
              >
                {{ btn.label }}
              </el-button>
            </div>
            <div
              class="item dial_img"
              v-if="btn.showDial"
              :key="`${Math.random()}-${key}`"
            >
              <el-tooltip
                effect="dark"
                content="添加至待拨打"
                placement="bottom"
              >
                <img
                  :src="require('@/assets/images/customer/phone2-icon.png')"
                  v-if="btn.addToDial"
                  @click="btn.method(key, scope.row)"
                />
              </el-tooltip>
              <el-tooltip effect="dark" content="拨打电话" placement="bottom">
                <img
                  :src="require('@/assets/images/customer/phone1-icon.png')"
                  v-if="btn.dialToPhone"
                  @click="btn.method(key, scope.row)"
                />
              </el-tooltip>
            </div>
          </template>
        </template>
      </el-table-column>

      <el-table-column
        v-if="isCall"
        class="column-sort"
        fixed="right"
        width="40px"
      >
        <template slot-scope="scope">
          <div class="flex-al flex-sb">
            <img
              style="width: 15px; cursor: pointer"
              @click="emitCallPhone(scope.row)"
              src="data:image/png;base64,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"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 意向各户***排序方式 -->
      <el-table-column
        v-if="isSort"
        class="column-sort"
        :fixed="tableSort.fixed"
        :label="tableSort.label"
        :align="tableSort.align"
        width="40px"
      >
        <template slot="header" slot-scope="scope">
          <el-dropdown class="btn-sort" @command="handleCommandSort">
            <span class="el-dropdown-link">
              <i class="icon-sort"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in tableSort.sortOption"
                :key="item.field"
                divided
                :command="item.field"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <!-- 自定义列 -->
      <el-table-column
        v-if="issetting"
        :fixed="tableOperate.fixed"
        :label="tableOperate.label"
        :align="tableOperate.align"
        width="40px"
        :render-header="renderHeader"
      >
        <!-- <template slot-scope="scope"></template> -->
      </el-table-column>
    </el-table>
    <!-- {{total.dataNumber}} -->
    <!-- 分页 -->
    <!-- <el-pagination
      v-if="isPagination"
      style="margin-top: 35px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="8"
    ></el-pagination>-->
  </div>
</template>

<script>
export default {
  name: "tableList",
  props: {
    total: Number, //分页数据
    pagesize: Number, //分页条数
    issetting: null, //是否可编辑列
    isSort: null, //是否显示排序方式
    isCall: null,
    list: {
      type: Array,
      // default: []
    }, // 数据列表
    isCheckbox: null,
    isPagination: null,
    columns: {
      type: Array,
      // default: []
    }, // 需要展示的列 === prop：列数据对应的属性，label：列名，align：对齐方式，width：列宽
    operates: {}, // 操作按钮组 === label: 文本，type :类型（primary / success / warning / danger / info / text），show：是否显示，icon：按钮图标，plain：是否朴素按钮，disabled：是否禁用，method：回调方法
    options: {
      type: Object,
      // default: {
      //   highlightCurrentRow: false // 是否要高亮当前行
      // }
    }, // table 表格的控制参数
    tableOperate: {
      type: Object,
    },
    tableSort: {
      type: Object,
    },
  },
  data() {
    return {
      companyId: "",
      marketer_id: "",
      currentPage: 1,
      num: 10,
      size: 10,
      postbe_crmlevel: "", // 权限判断
    };
  },
  created() {
    this.num = this.total;
    this.size = this.pagesize;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;

    this.marketer_id = this.$store.state.MARKETER_ID;
    // this.tableHeight=parseInt(this.getClientHeight());
    this.companyId = this.$store.state.COMPANY_ID;
  },
  watch: {
    total(newdata, olddata) {
      (() => {})(newdata, olddata);
      this.num = this.newdata;
    },
    pagesize(newdata, olddata) {
      (() => {})(newdata, olddata);
      this.size = this.newdata;
    },
  },
  computed: {
    companyIsmajor() {
      return this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    },
    postbeCrmlevel() {
      return this.$store.state.POSTBE_CRMLEVEL;
    },
  },
  methods: {
    emitCallPhone(val) {
      this.$emit("emitCallPhone", val);
    },
    // 获取窗口高度
    // getClientHeight(height) {
    //     var clientHeight = 0;
    //     if (document.body.clientHeight && document.documentElement.clientHeight) {
    //         var clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
    //     } else {
    //         var clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
    //     }
    //     return clientHeight - height;
    // },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.$emit("handleSelectionChange", val);
    },
    handleColumnChange(k, v) {
      (() => {})(k, v);
      this.$emit("handleColumnChange", k, v);
    },
    handleCodeChange(k, v, col) {
      (() => {})(k, v);
      this.$emit("handleCodeChange", k, v, col);
    },
    // 点击功能菜单***8获取每条数据
    dropdownClick(row) {
      this.$emit("dropdownClick", row);
    },
    // 点击功能菜单
    handleCommand(command) {
      this.$emit("handleCommand", command);
    },
    // 点击排序方式***功能菜单
    handleCommandSort(command) {
      this.$emit("handleCommandSort", command);
    },
    renderHeader(h, { column, $index }) {
      (() => {})(h, column, $index);
      return h("span", {
        class: "el-icon-setting",
        on: {
          click: () => {
            (() => {})(`${column.label}----${$index}`);
            this.$emit("toggleEditableColumn");
          },
        },
      });
    },
    checkboxInit(row, index) {
      if (row.client_distributionstatus == "0") {
        //这个判断根据你的情况而定
        return 1; //可勾选
      } else {
        return 0; //不可勾选
      }
    },
    checkboxInitTwo(row, index) {
      if (row.client_tracestatus != "4") {
        //这个判断根据你的情况而定
        return 1; //可勾选
      } else {
        return 0; //不可勾选
      }
    },
    // 分页
    // handleSizeChange(val) {
    //   (() => {})(`每页 ${val} 条`);
    //   (() => {})(this.total.dataNumber);
    // },
    // handleCurrentChange(val) {
    //   (() => {})(`当前页: ${val}`);
    // }
  },
};
</script>

<style lang="less">
.item {
  display: inline-block;
  .btn-noclick {
    color: #aaa;
  }
}
.cell {
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.dial_img {
  display: inline-flex !important;
  align-items: center;
  img {
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
}

.item + .item {
  margin-left: 15px !important;
}

.link-type {
  font-weight: normal;
}

.table-code {
  width: 40px;
  margin: 0 auto;

  img {
    width: 100%;
  }
}

.el-icon-setting {
  display: block;
  width: 20px;
  height: 20px;
  font-size: 18px;
  margin: 0 auto;
  color: #aaa;
  // background-color: green;
  cursor: pointer;
}
.el-tooltip__popper.is-dark {
  max-width: 500px;
}

// 排序方式
.btn-sort {
  padding: 0px !important;
  .icon-sort {
    display: block;
    width: 15px;
    height: 15px;
    cursor: pointer;
    background: url("../../assets/images/icon/sort.svg") no-repeat;
    background-size: 100% 100%;
  }
}
.column-sort {
}
.tableDiv {
  .phone-tips {
    display: inline-block;
    width: 30px;
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    background: rgba(39, 170, 216, 0.15);
    border-radius: 2px;
    color: #27aad8;
    margin-left: 4px;
    &.field-phone {
      background: rgba(252, 84, 104, 0.15);
      color: #fb586c;
    }
  }
  .no-readTips {
    display: inline-block;
    width: 30px;
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    background: rgba(252, 84, 104, 0.15);
    color: #fb586c;
    border-radius: 2px;
    margin-left: 4px;
  }
}
</style>
